import {useMutation} from "@tanstack/react-query";
import {setUserTypeClaims} from "../services/ClaimService";

export function useSetUserTypeClaims() {
    return useMutation({
        mutationFn: setUserTypeClaims,
    });
}
